import { render, staticRenderFns } from "./Dragger.vue?vue&type=template&id=7b4595ee&"
import script from "./Dragger.vue?vue&type=script&lang=js&"
export * from "./Dragger.vue?vue&type=script&lang=js&"
import style0 from "./Dragger.vue?vue&type=style&index=0&id=7b4595ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports